export default __webpack_public_path__ + "static/media/ppdark.f6adc289.png";